export const HEADER_CORNDER_RADIUS = 20;
